import React from 'react';

const CrmContactForm = () => {
  return (
    <section className="bg-white py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Detailed Booking & Consultation Form
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            For comprehensive inquiries, event bookings, and to schedule a consultation, please use the detailed form below. We will contact you as soon as possible.
          </p>
        </div>

        {/* Iframe Container */}
        <div className="rounded-2xl shadow-2xl border border-border overflow-hidden">
          <iframe
            title="Luxe CRM Contact Form"
            width="100%"
            height="850"
            src="https://luxe.mojescrm.co.ke/forms/wtl/1f72636ed9e0add36008563cc89984d2"
            frameBorder="0"
            sandbox="allow-top-navigation allow-forms allow-scripts allow-same-origin allow-popups"
            allowFullScreen
            style={{ display: 'block' }} // Ensures the iframe is a block element to prevent extra space
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default CrmContactForm;